var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"SidePanel"},[_c('ce-panel-header',{attrs:{"title":_vm.title}}),_c('ce-panel-body',{attrs:{"config":_vm.config,"on-change":_vm.handleChange}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }